import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect() {
    this.filter = this.filter.bind(this)
    this.servicesChanged = this.servicesChanged.bind(this)

    addEventListener('input:change', this.servicesChanged)
  }

  disconnect() {
    removeEventListener('input:change', this.servicesChanged)
  }

  servicesChanged(event) {
    if (event.detail.name !== 'service_definition_ids') {
      return
    }
    this.filter()
  }

  filter() {
    this.element.requestSubmit()
  }
}
